var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1512,
    height: 945,
    viewBox: "0 0 1512 945",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1512,
    height: 945
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 945,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17.8258,
    y: -5.10544,
    width: 1574.53,
    height: 892.203,
    fill: "#66F3B0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.0566 415.422L793.49 -18.6739L1158.74 -18.6739L1605.73 97.0851L38.6429 744.094L-10.0566 415.422Z",
    fill: "url(#paint0_linear_3_230)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 333.672,
    ry: 113.405,
    transform: "matrix(0.90598 -0.423319 0.314056 0.949404 962.398 244.138)",
    fill: "#3DADFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 333.672,
    ry: 113.405,
    transform: "matrix(0.90598 -0.423319 0.314056 0.949404 715.389 329.366)",
    fill: "#3DADFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.548 26.5281C547.288 53.4049 328.684 104.919 113.849 26.5281C102.542 20.5554 93.8733 26.976 149.655 100.439C219.382 192.269 447.409 154.193 722.548 26.5281Z",
    fill: "#AFFF89"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.722 39.2344C519.719 60.5511 346.338 101.408 175.947 39.2344C166.979 34.4974 160.103 39.5897 204.345 97.8554C259.648 170.687 440.502 140.489 658.722 39.2344Z",
    fill: "#AFFF89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M732.333 342.944C1068.01 169.306 1207.16 161.037 1528.92 227.185L1635.02 450.435L83.5797 956.879C55.1715 951.367 137.497 812.181 361.865 601.334C404.158 561.59 396.652 516.582 732.333 342.944Z",
    fill: "url(#paint1_linear_3_230)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956.697 291.266C1312.13 187.03 1207.15 161.038 1528.92 227.185L1635.02 450.435L95.7535 952.745C67.3453 947.233 34.8788 830.371 132.278 663.348C254.028 454.569 688.848 369.816 956.697 291.266Z",
    fill: "#81F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.565 494.208C1236.6 389.972 1216.78 293.698 1572.58 359.846L1622.76 583.095L-79.3124 1085.41C-110.725 1079.89 -146.626 963.032 -38.9241 796.008C95.7033 587.229 547.385 572.758 843.565 494.208Z",
    fill: "#81F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 333.672,
    ry: 113.405,
    transform: "matrix(0.90598 -0.423319 0.314056 0.949404 318.412 495.177)",
    fill: "#70A9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter8_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 399.69,
    ry: 165.748,
    transform: "matrix(0.937239 -0.348688 0.2547 0.96702 1077.82 549.649)",
    fill: "#26F177"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 333.672,
    ry: 113.405,
    transform: "matrix(0.90598 -0.423319 0.314056 0.949404 1368.33 419.549)",
    fill: "#BAFFDE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 299.835,
    ry: 174.69,
    transform: "matrix(0.90598 -0.423319 0.314056 0.949404 3.10701 573.343)",
    fill: "url(#paint2_linear_3_230)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-338 854.571V1356H1846V336L-338 854.571Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 115.488,
    ry: 396.097,
    transform: "matrix(0.52776 0.849393 -0.80789 0.589334 1282.95 536.528)",
    fill: "#78FF86"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter13_f_3_230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 115.488,
    ry: 396.097,
    transform: "matrix(0.52776 0.849393 -0.80789 0.589334 967.953 586.528)",
    fill: "#53F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_3_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017 231.559L1731 -153L1553.82 310L1017 231.559Z",
    fill: "#51ED99"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3_230",
    x: -17.0566,
    y: -25.6739,
    width: 1629.79,
    height: 776.768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3_230",
    x: 493.977,
    y: -97.4772,
    width: 936.842,
    height: 683.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3_230",
    x: 246.968,
    y: -12.2494,
    width: 936.842,
    height: 683.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3_230",
    x: 37.4899,
    y: -43.1761,
    width: 753.059,
    height: 262.246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3_230",
    x: 133.317,
    y: 1.88278,
    width: 561.405,
    height: 172.129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3_230",
    x: 52.8257,
    y: 176.899,
    width: 1596.19,
    height: 789.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3_230",
    x: -157.3,
    y: 292.1,
    width: 1826.06,
    height: 839.306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3_230",
    x: -150.008,
    y: 153.561,
    width: 936.842,
    height: 683.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3_230",
    x: 536.811,
    y: 173.246,
    width: 1082.02,
    height: 752.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3_230",
    x: 899.913,
    y: 77.9337,
    width: 936.842,
    height: 683.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3_230",
    x: -438.076,
    y: 200.486,
    width: 882.366,
    height: 745.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_3_230",
    x: -470,
    y: 204,
    width: 2448,
    height: 1284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3_230",
    x: 825.138,
    y: 151.256,
    width: 915.63,
    height: 770.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_3_230",
    x: 510.138,
    y: 201.256,
    width: 915.63,
    height: 770.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_3_230",
    x: 901,
    y: -269,
    width: 946,
    height: 695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58,
    result: "effect1_foregroundBlur_3_230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_230",
    x1: 797.839,
    y1: -18.6739,
    x2: 98.3227,
    y2: 540.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_230",
    x1: 1214.11,
    y1: 280.931,
    x2: 454.634,
    y2: 537.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65537,
    stopColor: "#FFEB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_230",
    x1: 392.416,
    y1: 103.122,
    x2: 278.355,
    y2: 338.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51DBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51EEB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsBackground);
export default __webpack_public_path__ + "static/media/documents-background.5bc3043fea4d2b27edbf75a080991401.svg";
export { ForwardRef as ReactComponent };